<!-- PASSWD INPUT -->
<div class="validable-input-margins" [formGroup]="formGroup">
  <div class="input-group">
    <div class="input-group-prepend form-icon col-1 justify-content-center align-items-center">
      <i class="material-icons notranslate">{{icon}}</i>
    </div>
    <div class="col left--20 mt-1 mb-4 {{this.classes}}">
        <ngx-intl-tel-input
          #internalInput
          [cssClass]="'custom tel-plugin-input'"
          [preferredCountries]="preferredCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="selectedCountryISOVar"
          [maxLength]="20"

          [phoneValidation]="true"
          [separateDialCode]="true"
          name="phone"
          formControlName="phone">
        </ngx-intl-tel-input>

      <app-field-error-display [displayError]="isFieldNotValid(customId)"
                               [errorMsg]="getErrorText() | translate"
                                class="tel-input-error-container">
      </app-field-error-display>
    </div>
  </div>
</div>
